export default "__VITE_ASSET__G1xnhFq5__"